export default {
  forgot_password_submit: {
    title: 'รีเซ็ตรหัสผ่าน',
    submit_complete: 'ส่งเรียบร้อยแล้ว',
    password_reset: 'รีเซ็ตรหัสผ่านแล้ว',
  },
}
